export default {"src":"/_next/static/media/linkedin.9a187b28.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};